import { LoginDashboardService } from '../services/LoginDashboardService';

export function useLoginDashboardService(): LoginDashboardService {
  return new LoginDashboardService(useApiClient(), useUserStore());
}
